import { useNavigate, useSearchParams } from 'react-router-dom';
import { Onboarding } from '@ofself/shell';
import { joinNext, withNext } from '../../utils/joinFlow';
import JoinFrame from './JoinFrame';

// JOIN, HELD — the account exists but cannot sign in until it is approved.
// Says so plainly, rather than the bare toast a login attempt would give, and
// keeps `next` so signing in later still ends where the person started.
function JoinPending() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const next = joinNext(searchParams);

  return (
    <JoinFrame>
      <Onboarding.Step
        title="Your account is waiting for approval"
        subtitle="Your ofSelf account was created. You can sign in as soon as it is approved."
        centered
      >
        <Onboarding.Next onClick={() => navigate(withNext('/login', next))}>Go to sign in</Onboarding.Next>
      </Onboarding.Step>
    </JoinFrame>
  );
}

export default JoinPending;
